import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from './BaseComponent';
import Button from '../CommonSet/Button';
import { compStatusTypes } from '../../Constants';
import Media from '../CommonSet/Media';

class Report extends BaseComponent {
    constructor(props) {
        super(props);
    }

    /* Lifecycle Api */
    shouldComponentUpdate(nextProps) {
        if (
            this.props.reportStatus === compStatusTypes.HIDDEN &&
            nextProps.reportStatus === compStatusTypes.HIDDEN
        ) {
            return false;
        }
        return true;
    }

    /* Lifecycle Api */

    /* Event Handler */

    /* Event Handler */

    /* User Function */

    createPrefixText(idx) {
        return `<strong>${this.getLang('General.questions')} ${idx +
            1}) </strong>`;
    }

    createResultText() {
        if (this.props.reportStatus === compStatusTypes.HIDDEN) {
            return null;
        }

        let correctCount = 0;
        let questionsCount = 0;
        Object.keys(this.props.answerData).forEach((key) => {
            const answerData = this.props.answerData[key];
            const createdItems = this.props.createdItems[key];
            let isCorrect = true;
            Object.keys(createdItems).forEach((innerKey) => {
                if (
                    (createdItems[innerKey].isCorrect &&
                        !answerData[innerKey]) ||
                    (answerData[innerKey] && !createdItems[innerKey].isCorrect)
                ) {
                    isCorrect = false;
                }
            });

            questionsCount += 1;
            if (isCorrect) {
                correctCount += 1;
            }
        });

        return this.format(
            this.getLang('Msgs.quiz_complete2'),
            `<b>${questionsCount}</b>`,
            `<b>${correctCount}</b>`
        );
    }

    getBtnRetryClassName() {
        const hidden = this.props.isCheckAnwser ? 'hidden' : '';
        return `${this.Styles.btnRetry} ${hidden}`;
    }

    getResultViewClassName() {
        let hidden = '';
        if (this.props.isHomework && !this.props.isHomeworkLapse) {
            hidden = 'hidden';
        }

        return `${this.Styles.resultView} ${hidden}`;
    }

    createIconClassName(isCorrect, answer) {
        let iconName = '';
        if (isCorrect) {
            iconName = 'correct';
        } else if (!isCorrect && answer) {
            iconName = 'incorrect';
        }
        return `${this.Styles.answer} ${iconName}`;
    }

    createItemText(items, answer) {
        let itemText = null;

        if (items && answer) {
            itemText = items.map((item, idx) => (
                <div
                    key={idx}
                    className={this.createIconClassName(
                        item.isCorrect,
                        answer[idx]
                    )}
                >
                    <span className={this.Styles.icon} />
                    <div className={this.Styles.answerText}>
                        <span>{`${idx + 1}) `}</span>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: this.getAnswerView(item.text),
                            }}
                        />
                    </div>
                </div>
            ));
        }
        return <div>{itemText}</div>;
    }

    createRenderView(content) {
        const wrapper = Entry.createElement('div');
        if (content) {
            $('body').append(wrapper);
            wrapper.addClass(this.Styles.editorBlock);
            wrapper.addClass('blocks');
            wrapper.contentEditable = false;
            $(wrapper).attr('block', content);
            const renderView = new Entry.RenderView(wrapper, 'LEFT_MOST');
            renderView.changeCode(new Entry.Code(JSON.parse(content)), true);
            $(wrapper).detach();
        }
        return wrapper;
    }

    getAnswerView(answerText) {
        let content = '';

        if (answerText) {
            content = answerText.replace(/\*\*\*.*?\*\*\*/gim, (item) => {
                let block = item.substring(3, item.lastIndexOf('***'));
                return $('<div>')
                    .append(this.createRenderView(block))
                    .html();
            });
        }

        return content;
    }

    getResultView() {
        const result = this.props.questionsData.map((quest, idx) => {
            let content = '';
            if (quest.content) {
                content = quest.content.replace(
                    /\*\*\*.*?\*\*\*/gim,
                    (item) => {
                        let block = item.substring(3, item.lastIndexOf('***'));
                        return $('<div>')
                            .append(this.createRenderView(block))
                            .html();
                    }
                );
            }

            return (
                <div key={idx} className={this.Styles.question}>
                    <div
                        className={this.Styles.content}
                        dangerouslySetInnerHTML={{
                            __html: this.createPrefixText(idx) + content,
                        }}
                    />
                    <Media media={quest.media} />
                    <div className={this.Styles.answerData}>
                        {this.createItemText(
                            this.props.createdItems[idx],
                            this.props.answerData[idx]
                        )}
                    </div>
                </div>
            );
        });

        return <div>{result}</div>;
    }

    /* User Function */
    render() {
        if (this.props.reportStatus === compStatusTypes.HIDDEN) {
            return null;
        }

        return (
            <div className={`${this.Styles.report} ${this.props.reportStatus}`}>
                <div className={this.Styles.basicView}>
                    <div className={this.Styles.text}>
                        <div>
                            {`'${this.props.text}' ${this.getLang(
                                'Msgs.quiz_complete1'
                            )}`}
                        </div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: this.createResultText(),
                            }}
                        />
                    </div>
                    <div>
                        <Button
                            className={this.getBtnRetryClassName()}
                            text={this.getLang('Buttons.quiz_retry')}
                            onClick={this.props.onClickRetry}
                        />
                        <Button
                            text={this.getLang('Buttons.confirm')}
                            onClick={this.props.onClickConfirm}
                        />
                    </div>
                </div>
                <div className={this.getResultViewClassName()}>
                    {this.getResultView()}
                </div>
            </div>
        );
    }
}

Report.displayName = 'Report';
Report.propTypes = {
    text: PropTypes.string.isRequired,
    answerData: PropTypes.object.isRequired,
    createdItems: PropTypes.object.isRequired,
    questionsData: PropTypes.array.isRequired,
    reportStatus: PropTypes.oneOf(Object.keys(compStatusTypes)),
    isCheckAnwser: PropTypes.bool.isRequired,
    isHomeworkLapse: PropTypes.bool.isRequired,
    onClickRetry: PropTypes.func.isRequired,
    onClickConfirm: PropTypes.func.isRequired,
};

Report.defaultProps = {
    text: '',
    answerData: {},
    createdItems: {},
    questionsData: [],
    reportStatus: compStatusTypes.ENABLED,
    isCheckAnwser: false,
    isHomeworkLapse: false,
};

export default Report;



// WEBPACK FOOTER //
// ./components/QuizSet/Report.js